<template>
<svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28 0V36L2.28746 20.5725C0.345448 19.4073 0.345448 16.5927 2.28746 15.4275L28 0Z" fill="white"/>
</svg>
</template>